export default __webpack_public_path__ + "dist/media/projectFolderCircle.368af54c.svg";